var map = {
	"./1.svg": 987,
	"./2.svg": 988,
	"./3.svg": 989,
	"./CloudGuard-Service.svg": 990,
	"./DNS.svg": 991,
	"./ManagedService-Service.svg": 992,
	"./VPC-Service.svg": 993,
	"./VPS-Service.svg": 994,
	"./ddos-d.svg": 995,
	"./ddos-image.svg": 924,
	"./ddos.svg": 996,
	"./devops.svg": 997,
	"./exclusive.svg": 998,
	"./firewall-ability.1bb527e 1.svg": 999,
	"./firewall-setting.cc1ac98 1.svg": 1000,
	"./focus.svg": 1001,
	"./hardening.svg": 1002,
	"./limitation.cb39432 1.svg": 1003,
	"./monitoring.svg": 1004,
	"./technical.svg": 1005,
	"./traffic-vps.aa00c67 1.svg": 1006,
	"./waf-d.svg": 1007,
	"./waf-icon-active.svg": 1008,
	"./waf-icon.svg": 1009,
	"./waf.svg": 1010
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1143;